export class PhotoSuggestion {
    public suggestionId: number;
    public photoId: number;
    public userId: number;
    public suggestionDate: Date;
    public suggestionType: string;
    public suggestionAction: string;
    public suggestionValue: string;
}